/** Same wording as business-api / legacy FE when creating a payment release request. */

type PaymentRequestMessageLike = {
  milestone?: { name?: string | null } | null;
  request?: {
    text?: string | null;
    metadata?: {
      isSubmilestone?: boolean;
      subMilestone?: { name?: string | null };
      milestone?: { name?: string | null };
    };
  };
};

/** Same wording as business-api / legacy FE when creating a payment release request. */
export function getMilestonePaymentRequestDefaultTitle(message: PaymentRequestMessageLike): string {
  const meta = message.request?.metadata;
  if (!meta) {
    return "Milestone Completion";
  }
  if (meta.isSubmilestone && meta.subMilestone?.name) {
    return `Payment request for submilestone "${meta.subMilestone.name}"`;
  }
  const mName = meta.milestone?.name || message.milestone?.name || "Milestone";
  return `Payment request for milestone "${mName}"`;
}

/** Optional user note only; null when empty or when request.text is only the legacy auto line. */
export function getMilestonePaymentRequestUserNote(message: PaymentRequestMessageLike): string | null {
  const text = message.request?.text?.trim();
  if (!text) {
    return null;
  }

  // Backward compatibility: legacy sub-milestone requests used the milestone title
  // (instead of "Payment request for submilestone ...") as the auto-created text.
  const meta = message.request?.metadata;
  if (meta?.isSubmilestone) {
    const legacyMilestoneName = meta.milestone?.name || message.milestone?.name || "Milestone";
    const legacyAutoTitle = `Payment request for milestone "${legacyMilestoneName}"`;
    if (text === legacyAutoTitle) {
      return null;
    }

    // Fallback: hide any legacy auto-text that matches the old prefix shape.
    if (text.startsWith('Payment request for milestone "')) {
      return null;
    }
  }

  if (text === getMilestonePaymentRequestDefaultTitle(message)) {
    return null;
  }
  return text;
}

